import React from 'react';
import { motion } from 'framer-motion';
export function MockupSection() {
  return;
}